import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuick = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 41,
	height: 12,
	viewBox: "0 0 41 12",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9804_9671)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_9804_9671",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 41,
			height: 12,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M41 0H0V12H41V0Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_9804_9671)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M11.9292 9.70757C11.9292 10.1317 11.8026 10.5463 11.5654 10.8989C11.3282 11.2515 10.9911 11.5264 10.5966 11.6887C10.2021 11.851 9.76812 11.8934 9.34938 11.8107C8.93061 11.728 8.54597 11.5237 8.24409 11.2238C7.94219 10.924 7.73658 10.5419 7.65328 10.1259C7.57001 9.70994 7.61276 9.27879 7.77612 8.88696C7.93952 8.49513 8.21619 8.16023 8.5712 7.92462C8.92619 7.68898 9.34356 7.56323 9.7705 7.56323C10.343 7.56323 10.8921 7.78915 11.2969 8.19131C11.7018 8.59343 11.9292 9.13886 11.9292 9.70757Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.2797 3.14038H19.9295V6.82542C19.9295 7.87273 19.5107 8.8771 18.7652 9.61766C18.0196 10.3582 17.0085 10.7742 15.9542 10.7742C14.8999 10.7742 13.8888 10.3582 13.1433 9.61766C12.3978 8.8771 11.979 7.87273 11.979 6.82542V3.14038H14.6288V6.82542C14.6288 6.99834 14.6631 7.16953 14.7297 7.32929C14.7963 7.48902 14.8939 7.63415 15.017 7.75643C15.1401 7.87867 15.2862 7.97568 15.447 8.04184C15.6078 8.108 15.7802 8.14207 15.9542 8.14207C16.1283 8.14207 16.3007 8.108 16.4614 8.04184C16.6223 7.97568 16.7684 7.87867 16.8915 7.75643C17.0145 7.63415 17.1122 7.48902 17.1788 7.32929C17.2454 7.16953 17.2797 6.99834 17.2797 6.82542V3.14038Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.6484 3.14038H20.9976V10.5105H23.6484V3.14038Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.4223 5.50992C28.655 5.5097 28.8836 5.57033 29.0852 5.68569C29.2867 5.80108 29.4542 5.96712 29.5708 6.16714L31.8643 4.84837C31.4267 4.09569 30.7513 3.50747 29.9428 3.17491C29.1344 2.84238 28.238 2.78411 27.3928 3.00915C26.5476 3.23418 25.8008 3.72994 25.2681 4.41956C24.7355 5.10918 24.4468 5.95411 24.4468 6.82332C24.4468 7.69253 24.7355 8.53746 25.2681 9.22708C25.8008 9.91667 26.5476 10.4125 27.3928 10.6375C28.238 10.8625 29.1344 10.8043 29.9428 10.4717C30.7513 10.1392 31.4267 9.55095 31.8643 8.79824L29.5708 7.48376C29.4544 7.68366 29.2872 7.84961 29.0859 7.96499C28.8846 8.08035 28.6563 8.14105 28.4238 8.14102C28.1914 8.14095 27.9631 8.08016 27.7618 7.96471C27.5606 7.84926 27.3934 7.68322 27.2772 7.48329C27.161 7.28333 27.0998 7.05656 27.0998 6.82569C27.0997 6.59482 27.1609 6.36798 27.277 6.16803C27.3932 5.96804 27.5602 5.80196 27.7615 5.68645C27.9627 5.5709 28.191 5.51005 28.4234 5.50992",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.0106 10.5105L37.0324 6.82441L40.7421 3.14042H37.3022L35.1273 5.30192V0.0461426H32.4775V10.5105H35.1273V8.35011L37.3022 10.5105H41.0106Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.86569 9.70001C6.86601 9.24941 6.97261 8.80519 7.17691 8.4029C7.38124 8.00062 7.67758 7.65148 8.04223 7.3835C8.40688 7.11549 8.82968 6.93609 9.27671 6.8597C9.72374 6.78328 10.1826 6.81196 10.6164 6.94345C10.9654 5.79407 10.918 4.56186 10.4816 3.44233C10.0452 2.3228 9.2449 1.38013 8.20772 0.763914C7.17052 0.147696 5.95587 -0.106758 4.75648 0.0409351C3.55712 0.188628 2.44176 0.730007 1.58744 1.57915C0.733121 2.42829 0.188781 3.53656 0.0408128 4.72803C-0.107155 5.91951 0.149726 7.12595 0.770689 8.15586C1.39165 9.18581 2.34111 9.98021 3.46841 10.413C4.59569 10.8458 5.83618 10.8922 6.99304 10.5449C6.90875 10.2711 6.86585 9.98634 6.86569 9.70001ZM2.79113 5.38453C2.79092 4.86742 2.94509 4.36191 3.23417 3.93186C3.52324 3.50185 3.93419 3.16664 4.41506 2.96867C4.89594 2.7707 5.42513 2.71884 5.93569 2.81967C6.44625 2.92049 6.91524 3.16945 7.28332 3.53511C7.65139 3.90073 7.90204 4.36658 8.00352 4.87374C8.10503 5.38089 8.05281 5.90656 7.85353 6.38425C7.65422 6.86195 7.31678 7.27017 6.88387 7.55732C6.45095 7.84446 5.94204 7.99759 5.4215 7.9974C4.7239 7.9974 4.05484 7.72209 3.56153 7.23208C3.06826 6.74207 2.79113 6.07749 2.79113 5.38453Z",
					fill: "currentColor"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9804_9671",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 41,
			height: 12,
			fill: "white"
		})
	}) })]
});
export default SvgQuick;
